import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/t/$tenantId/code-remedy')({
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace('/code-remedy', '/code-modernization'), replace: true });
  },
});
